module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-date-a0ae7ea09c49e4ba131aa8427404d6d6.png";